export default "__VITE_ASSET__DiRRHZMO__"